import React from 'react';
import { Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useAppTheme } from '../../theme/ThemeProvider';
import './SymbolSelector.css';

export interface SymbolOption {
  symbol: string;
  name: string;
  color: string;
}

export interface SymbolSelectorProps {
  selectedSymbol: string;
  onSymbolChange: (symbol: string) => void;
  className?: string;
  size?: 'small' | 'middle' | 'large';
}

const SymbolSelector: React.FC<SymbolSelectorProps> = ({
  selectedSymbol,
  onSymbolChange,
  className = '',
  size = 'middle'
}) => {
  const { t } = useTranslation();
  const { theme, themeName } = useAppTheme();
  const [isOpen, setIsOpen] = React.useState(false);

  const symbolOptions: SymbolOption[] = [
    {
      symbol: 'BTCUSDT',
      name: 'Bitcoin',
      color: '#f7931a'
    },
    { symbol: 'ETHUSDT', name: 'Ethereum', color: '#627eea' },
    { symbol: 'BNBUSDT', name: 'BNB', color: '#f3ba2f' },
    { symbol: 'SOLUSDT', name: 'Solana', color: '#14f195' },
    { symbol: 'XRPUSDT', name: 'XRP', color: '#23292f' }
  ];

  const selectedOption = symbolOptions.find(option => option.symbol === selectedSymbol);

  return (
    <div className={`symbol-selector ${className}`}>
      <div className={`symbol-dropdown-container ${isOpen ? 'open' : ''}`}>
        <Select
          value={selectedSymbol}
          onChange={onSymbolChange}
          size={size}
          className="symbol-dropdown pill"
          style={{
            minWidth: 140,
            color: theme.textPrimary
          }}
          styles={{
            popup: {
              root: {
                backgroundColor: theme.surfaceBackground,
                borderColor: theme.surfaceBorder
              }
            }
          }}
          popupMatchSelectWidth={false}
          suffixIcon={null}
          optionLabelProp="label"
          open={isOpen}
          onOpenChange={setIsOpen}
        >
        {symbolOptions.map((option) => (
          <Select.Option
            key={option.symbol}
            value={option.symbol}
            label={
              <div 
                className="symbol-pill-display"
                style={{
                  background: themeName === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)',
                  border: `1px solid ${themeName === 'dark' ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.12)'}`,
                  color: theme.textPrimary
                }}
              >
                <SearchOutlined className="symbol-search-icon" style={{ color: theme.textSecondary }} />
                <span className="symbol-code" style={{ color: theme.textPrimary }}>{option.symbol}</span>
              </div>
            }
          >
            <div className="symbol-option-row">
              <span className="symbol-swatch" style={{ backgroundColor: option.color }} />
              <span className="symbol-option-name">{option.name}</span>
              <span className="symbol-option-code">{option.symbol}</span>
            </div>
          </Select.Option>
        ))}
        </Select>
      </div>
    </div>
  );
};

export default SymbolSelector;